import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { EPersona } from '@norfolk-southern/accessns-components';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import * as CustomersByRoleActions from '@ruby/modules/customer-select/store/actions/role-customers.actions';
import * as fromCustomerByRole from '@ruby/modules/customer-select/store/reducers/role-customers.reducer';
import { selectThirdPartyCustomersByRole } from '@ruby/modules/third-party/store';
import { fromThirdPartyAuthorization, ThirdPartyAuthorizationActions } from '@ruby/modules/third-party/store/third-party-authorization.index';
import { fromThirdPartyCore } from '@ruby/modules/third-party/store/third-party-core.index';
import { fromThirdPartyStepper } from '@ruby/modules/third-party/store/third-party-stepper.index';
import { ERole } from '@ruby/shared/enums/roles.enums';
import { UtilsService } from '@ruby/shared/services/utils/utils.service';

@Component({
  selector: 'ng-third-party-locations-container',
  template: `
    <ng-third-party-locations *ngIf="(store$ | async) as store"
                              [customers]="customers"
                              [role]="role"
                              [editCustomerLoc]="customer"
                              [loading]="loading"
                              [isEdit]="store.stepper.isEdit"
                              (selectedLocations)="selectedLocations($event)">
    </ng-third-party-locations>
  `
})
export class ThirdPartyLocationsContainerComponent implements OnInit {
  customers!: Array<ICustomer>;
  role!: EPersona;
  customer?: ICustomer;
  loading!: boolean;
  store$: Observable<{
    core: fromThirdPartyCore.State;
    authorizations: fromThirdPartyAuthorization.State;
    stepper: fromThirdPartyStepper.State;
    customersByRole?: fromCustomerByRole.State;
  }>;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { role: ERole; customer?: ICustomer },
              private store: Store<fromThirdPartyAuthorization.State>,
              private utilsSvc: UtilsService) {
    this.role = this.utilsSvc.getTypeRoleMapping(this.data.role);
    this.store$ = this.store.select(selectThirdPartyCustomersByRole).pipe(
      tap((st: {
        core: fromThirdPartyCore.State;
        authorizations: fromThirdPartyAuthorization.State;
        stepper: fromThirdPartyStepper.State;
        customersByRole?: fromCustomerByRole.State;
      }) => {
        if (st.customersByRole) {
          this.loading = st.customersByRole.loading;
          this.customers = st.customersByRole.customers;
        }
      })
    );
  }

  ngOnInit(): void {
    this.store.dispatch(CustomersByRoleActions.loadRoleCustomers({ data: this.utilsSvc.getTypeRoleMapping(this.data.role) }));
    this.customer = this.data.customer;
  }

  /**
   * Select Locations
   *
   * @summary The following method dispatch an action with the selected locations and the type of the contract
   * @param $customer: ICustomer
   * @returns void
   */
  selectedLocations($customer: ICustomer): void {
    this.store.dispatch(ThirdPartyAuthorizationActions.setSelectedLocations({
      data: {
        type: this.utilsSvc.getTypeRoleMapping(this.data.role),
        customer: $customer
      }
    }));
  }
}
